// import { config } from 'app/config';
import { api } from 'api';

/**
 * get tariff template
 * @returns
 */
export const getTariffTemplate = () => {
  return api.call('tariff.get_data');
};

/**
 * get tariff templates
 * @returns
 */
export const getTariffTemplates = () => {
  return api.call('dictionaries.tarifficator');
};

/**
 * get tariff templates
 * @returns
 */
export const getTariff = (id) => {
  return api.call('tariff.view', { id });
};

/**
 * update tariff
 * @param {*} id
 * @param {*} data
 * @returns
 */
export const updateTariff = (id, data) => {
  return api.call('tariff.update', { ...data, id });
};

/**
 * archive tariff
 * @param {*} id
 * @returns
 */
export const archiveTariff = (id) => {
  return api.call('tariff.change_status', { id, status: 'archive' });
};

/**
 * get tariffs list
 * @param {*} filterParams
 * @param {*} sortParams
 * @param {*} callback
 * @returns
 */
export const getTariffList = (filterParams, sortParams) => {
  return api.call('tariff.list', { filter_params: filterParams || {}, sort_params: sortParams || [], paging_params: {} });
};

/**
 * add tariff
 * @param {*} data
 * @returns
 */
export const addTariff = (data) => {
  return api.call('tariff.add', data);
};
